var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 28",
    id: "svg6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-gradient",
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7A5FFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#845EC2; #D65DB1; #845EC2",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#845EC2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#845EC2; #D65DB1; #845EC2",
    dur: "4s",
    repeatCount: "indefinite"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M8.281 13.063L8 17.997c-.125 2.203 4.484 4 10 4s10.125-1.797 10-4l-.281-4.936-8.969 2.829c-.25.078-.5.107-.75.107s-.5-.03-.75-.107l-8.969-2.829z",
    style: {
      animation: "lcimgRrn_draw 948ms ease-out 0ms forwards"
    },
    fill: "none",
    fillOpacity: 1,
    stroke: "url('#logo-gradient')",
    strokeOpacity: 1,
    strokeDasharray: "54 56",
    strokeDashoffset: 55
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M7.656 10.766l-2.11-.657c-.968 1.36-1.436 3.329-1.53 5.157A2.006 2.006 0 003 16.998c0 .703.36 1.315.906 1.674L3 25.437a.511.511 0 00.5.563h3a.512.512 0 00.5-.563l-.906-6.765c.547-.36.906-.971.906-1.674 0-.734-.39-1.357-.984-1.701.125-2.11.75-3.828 1.64-4.531z",
    style: {
      animation: "lcimgRrn_draw 706ms ease-out 948ms forwards"
    },
    fill: "none",
    fillOpacity: 1,
    stroke: "url('#logo-gradient')",
    strokeOpacity: 1,
    strokeDasharray: "40 42",
    strokeDashoffset: 41
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "M18 2c-.047 0-.093 0-.156.016l-17.5 5.5A.523.523 0 000 8c0 .218.14.406.344.484l5.203 1.625 2.11.657 10.187 3.218c.062.016.109.016.156.016s.093 0 .156-.016l17.5-5.5A.522.522 0 0036 8a.523.523 0 00-.344-.484l-17.5-5.5C18.094 2 18.047 2 18 2z",
    style: {
      animation: "lcimgRrn_draw 1344ms ease-out 1655ms forwards"
    },
    fill: "none",
    fillOpacity: 1,
    stroke: "url('#logo-gradient')",
    strokeOpacity: 1,
    strokeDasharray: "77 79",
    strokeDashoffset: 78
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCap);
export default __webpack_public_path__ + "static/media/cap.6f15217c0a3011ba8a445e876930bb44.svg";
export { ForwardRef as ReactComponent };